import { Currency, Lang } from '@/i18n/types'

export const defaultLocale: Lang = 'bs'

export const locales: Lang[] = ['bs', 'en']

export const localesAlternates = [
  {
    langKey: 'x-default',
    lang: defaultLocale,
  },
  ...locales.map(l => ({ langKey: l, lang: l })),
]

export const otherLocales: Lang[] = locales.filter(l => l !== defaultLocale)

export const currencies: Currency[] = ['BAM', 'EUR', 'USD']
export const defaultCurrency: Currency = 'BAM'

export const i18nConfig = {
  locales,
  defaultLocale,
  prefixDefault: true,
}

export { default as initTranslations } from './init-translations'
export { default as TranslationsProvider } from './translation-provider'

export * from './helper'
export * from './types'
